import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import './ModalForms.css';

const ExpensesFiltersModal = ({
  isOpen,
  onClose,
  initialDateFrom = '',
  initialDateTo = '',
  initialCurrency = '',
  onApply
}) => {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [currency, setCurrency] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setDateFrom(initialDateFrom || '');
    setDateTo(initialDateTo || '');
    setCurrency(initialCurrency || '');
  }, [isOpen, initialDateFrom, initialDateTo, initialCurrency]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onApply?.({
      dateFrom,
      dateTo,
      currency
    });
  };

  return (
    <Modal
      title="Filtrar"
      isOpen={isOpen}
      onClose={onClose}
      footer={(
        <div className="modal-footer">
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" form="expenses-filters-modal-form" className="btn">
              Aceptar
            </button>
          </div>
        </div>
      )}
    >
      <form id="expenses-filters-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Filtrar por fecha (desde)
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </label>
          <label>
            Filtrar por fecha (hasta)
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </label>
          <label>
            Filtrar por moneda
            <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
              <option value="">Todas</option>
              <option value="USD">USD</option>
              <option value="$">$</option>
            </select>
          </label>
        </div>

      </form>
    </Modal>
  );
};

export default ExpensesFiltersModal;

